import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import { DATETIME_FORMAT_DATETIME } from '../../../../../utils/helpers/CommonHelper';

import 'dayjs/locale/sk';
import locale from 'antd/es/date-picker/locale/sk_SK';
import dayjs from 'dayjs';

const SimpleDateTimePicker = ({ value, onChange, classes, ...rest }) => {
  return (
    <DatePicker
      showTime
      defaultValue={dayjs(value)}
      onChange={(newDate) => {
        onChange(newDate);
      }}
      placeholder={` - `}
      format={DATETIME_FORMAT_DATETIME}
      locale={locale}
      size="large"
      style={{ width: '100%' }}
    />
  );
};

SimpleDateTimePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  classes: PropTypes.array,
};

export default SimpleDateTimePicker;
